import React from 'react'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
// core components
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardBody from 'components/Card/CardBody.jsx'

const styles = {
  cardCategoryWhite: {
    '&,& a,& a:hover,& a:focus': {
      color: 'rgba(255,255,255,.62)',
      margin: '0',
      fontSize: '14px',
      marginTop: '0',
      marginBottom: '0'
    },
    '& a,& a:hover,& a:focus': {
      color: '#FFFFFF'
    }
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: '#777',
      fontSize: '65%',
      fontWeight: '400',
      lineHeight: '1'
    }
  }
}

function TableList(props) {
  const { classes } = props
  return (
    <Grid container>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>このサイトについて</h4>
          </CardHeader>
          <CardBody>
            <p>
              HorieHがReact/ReactNativeで作ったWebツールやゲームアプリを公開しています。
            </p>
            <p>このページもReactでできています。</p>
          </CardBody>
        </Card>

        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>関連リンク</h4>
          </CardHeader>
          <CardBody>
            <ul>
              <li>
                <a href="https://twitter.com/h0rieh">Twitter</a>
              </li>
              <li>
                <a href="https://qiita.com/HorieH">Qiita</a>
              </li>
            </ul>
          </CardBody>
        </Card>
      </GridItem>
    </Grid>
  )
}

export default withStyles(styles)(TableList)
